import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import { OpusJob, OpusJobsCriteria } from '../models';
import { jobStates, KeyValue } from '../models/job-states.model';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';

@Component({
  selector: 'opus-jobs-header',
  templateUrl: './opus-jobs-header.component.html'
})
export class OpusJobsHeader implements OnInit, OnDestroy {
  @Input() opusJobs$: Observable<OpusJob[]>;
  @Output() criteriaChangeEvent = new EventEmitter<OpusJobsCriteria>();
  @Input() isEditing: boolean;

  private _alive = true;

  stateCtrl = new FormControl();
  states: KeyValue[] = jobStates;

  constructor(private store: Store<fromStore.OpusJobsState>) {}

  ngOnInit(): void {
    this.stateCtrl.valueChanges.pipe(takeWhile(() => this._alive)).subscribe((state: string) => {
      this.criteriaChangeEvent.emit({ state: state || '' });
    });

    this.store.dispatch(new fromStore.LoadOpusJobs({ state: '' }));
  }

  ngOnDestroy(): void {
    this._alive = false;
  }
}
